import { Link } from "react-router-dom";
import { useTrial } from "../context/TrialContext";

export default function TrialBanner() {
  const { trialInfo } = useTrial();

  if (!trialInfo || trialInfo.isSubscribed || trialInfo.trialExpired) return null;
  if (trialInfo.daysLeft > 6) return null;

  const urgent = trialInfo.daysLeft <= 1;

  return (
    <div className={`w-full px-4 py-2 text-sm text-center font-medium ${urgent ? "bg-red-500 text-white" : "bg-amber-400 text-amber-900"}`}>
      {urgent
        ? `Your free trial expires today! `
        : `${trialInfo.daysLeft} day${trialInfo.daysLeft !== 1 ? "s" : ""} left in your free trial. `}
      <Link to="/subscription" className="underline font-semibold">
        Subscribe now to keep access
      </Link>
    </div>
  );
}